@if (queryParams$ | async; as queryParams) {
  @if (queryParams?.from || queryParams?.to) {
    <div class="flex flex-row mt-4">
      <div class="flex flex-row">
        <strong>{{ '#TIMESTAMP.TABLE.APPLIED_FILTERS' | translate }}</strong>
      </div>
      <soft-chip-group class="flex flex-row">
        @if (queryParams?.from) {
          <soft-chip>
            <strong>{{ '#TIMESTAMP.TABLE.FROM' | translate }}</strong>
            {{ $safeNavigationMigration(queryParams?.from) | format: 'DATE.DEFAULT' }}
          </soft-chip>
        }
        @if (queryParams?.to) {
          <soft-chip class="ml-2">
            <strong>{{ '#TIMESTAMP.TABLE.TO' | translate }}</strong>
            {{ $safeNavigationMigration(queryParams?.to) | format: 'DATE.DEFAULT' }}
          </soft-chip>
        }
      </soft-chip-group>
    </div>
  }
}

<div class="grid mt-2">
  @for (group of dates$ | async | toArray; track group) {
    <div class="mt-2 card">
      <h5 class="font-bold stamp-day">{{ $safeNavigationMigration(group?.key) | date: 'dd.MM.yyyy' }}</h5>
      <ul>
        @for (timestamp of group | toArray | sortFunction: sortDates; track timestamp) {
          <li
            class="h-stack spacer"
            >
            <div class="item">
              <div class="item-row">
                <span class="stamp-title">{{
                  $safeNavigationMigration(timestamp?.timestamp) | date: 'HH:mm'
                }}</span>
                <span class="ml-4">{{
                  (timestamp.flag === 'arrival'
                  ? '#TIMESTAMP.TYPE.ARRIVAL'
                  : '#TIMESTAMP.TYPE.DEPARTURE'
                  ) | translate
                }}</span>
                @if (timestamp.code) {
                  <i
                    class="fa-regular fa-circle-info ml-2"
                    [softToolTip]="codeTemplate"
                    [toolTipPosition]="'right'"
                  ></i>
                }
                <ng-template #codeTemplate>
                  {{ timestamp.code.name }}
                  @if (timestamp.code.description) {
                    &nbsp;-&nbsp;{{ timestamp.code.description }}
                  }
                </ng-template>
              </div>
            </div>
            @if (timestamp.isDeletable) {
              <span
                class="delete-timestamp"
                (click)="onDelete(timestamp)"
                ><i class="fa-regular fa-trash remove-icon"></i
              ></span>
            }
          </li>
        }
      </ul>
    </div>
  }
</div>
